import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    sideNavItem: {
      padding: '0px',
      lineHeight: 1.3
    },
    menuItemIcon: {
      color: theme.palette.secondary.main,
      fontSize: 15,
      minWidth: theme.spacing(5)
    },
    menuItemText: {
      fontSize: 14
    },
    sideNavItemSelected: {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.primary.main,
      '& svg': {
        color: theme.palette.primary.main
      },
      '& span': {
        fontWeight: 'bolder'
      },
      '&:hover': {
        backgroundColor: theme.palette.grey[200]
      }
    },
    sideNavSubitemSelected: {
      color: theme.palette.secondary.main,
      '& span': {
        fontWeight: 'bolder'
      }
    },
    sideNavSubitem: {
      paddingLeft: '25px'
    }
  });
